import { IMenu } from 'src/types/menu.types';

export const getMenuById = (menus: IMenu[], menuId: string) => {
  return menus.find((menu) => menu.menuId === menuId);
};
